import * as React from 'react';
import styled from 'styled-components';


type FocusLockProps = {
    disabled?: boolean
    autoFocus?: boolean
    style?: React.CSSProperties
    className?: string
}

export const FocusHiddenInput = styled.input.attrs({ tabindex: 1 })`
    position:absolute;
    opacity:0;
`

const FocusLock: React.FC<FocusLockProps> = (props) => {
    const { disabled, autoFocus, style, className } = props;
    const ref = React.useRef<HTMLDivElement>(null);
    const selector = `
        button:not([tabindex="-1"]),
        [href]:not([tabindex="-1"]),
        [onclick]:not([tabindex="-1"]),
        input:not([tabindex="-1"]),
        select:not([tabindex="-1"]),
        textarea:not([tabindex="-1"]),
        [tabindex]:not([tabindex="-1"])
    `;

    const focusFirstElement = () => {
        let hiddenElements = ref.current?.querySelectorAll(FocusHiddenInput);
        let elements = Array.from(ref.current?.querySelectorAll(selector) || [])
        const useableElements = elements.filter(v => v !== hiddenElements?.[0] || elements.length === 1)
        let elem = useableElements[0] as HTMLElement | undefined;
        elem && elem.focus();
    }

    const handleKeypress = (ev: React.KeyboardEvent) => {
        if (disabled) return;
        if (ev.keyCode === 9) {
            const shiftKey = ev.shiftKey
            // Allow the browser to try to set focus outside.
            requestAnimationFrame(() => {
                if (!ref.current?.contains(document.activeElement)) {
                    let hiddenElements = ref.current?.querySelectorAll(FocusHiddenInput);
                    let elements = Array.from(ref.current?.querySelectorAll(selector) || [])
                    const useableElements = elements.filter(v => v !== hiddenElements?.[0] || elements.length === 1)
                    let first = useableElements[0] as HTMLElement | undefined;
                    let last = useableElements[useableElements.length - 1] as HTMLElement;
                    if (shiftKey) last.focus();
                    else first?.focus();
                }
            })
        }
    };

    React.useEffect(() => {
        if (autoFocus) requestAnimationFrame(() => focusFirstElement());
    }, []);

    return <>
        <span tabIndex={0} />
        <div onKeyDown={handleKeypress} style={style} className={className} ref={ref}>{props.children}</div>
        <span tabIndex={0} />
    </>
}

export default FocusLock;
export { FocusLock, FocusLockProps };